import { LoadingSpinner } from '../../LoadingSpinner/LoadingSpinner';

export const LoadingIndicator = LoadingSpinner;
